export const PERMISSIONS = [
  {
    view: "dasboard",
    isVisible: false,
    isExecute: false
  },
  {
    view: "jobs",
    isVisible: false
  },
  {
    view: "templates",
    isVisible: false,
    isEdit: false,
    isCreate: false,
    isDelete: false,
    isExecute: false,
  },
  {
    view: "workflow",
    isVisible: false,
    isEdit: false,
    isCreate: false,
    isDelete: false,
    isExecute: false,
  },
  {
    view: "dataModels",
    isVisible: false,
    isEdit: false,
    isCreate: false,
    isDelete: false,
  },
  {
    view: "documentations",
    isVisible: false,
  }
]